import { Component, Input } from '@angular/core';
import { C4InputConfig, SENSIBLE_DEFAULT_CONFIG } from './c4-input';

declare var module: any;

@Component({
  selector: 'c4-form',
  templateUrl: 'c4-form.html'
})
export class C4Form {
  @Input() config;

  ngOnInit() {
    this.config = this.config || SENSIBLE_DEFAULT_CONFIG;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/ui/src/app/directives/input/c4-form.ts